import { SEOHead } from "../components/SEOHead";

export function TermsOfService() {
  return (
    <div className="max-w-3xl mx-auto px-4 pb-16">
      <SEOHead
        title="Условия использования | Quantile Camp"
        description="Условия использования платформы Quantile Camp — права и обязанности пользователей."
        url="https://www.quantilecamp.ru/terms"
        noindex={true}
      />
      <h1 className="text-3xl font-heading font-semibold text-neutral-text mb-2">
        Условия использования
      </h1>
      <p className="text-sm text-neutral-text/50 font-body mb-8">
        Редакция от 15 марта 2025 г.
      </p>

      <div className="space-y-8 font-body text-neutral-text leading-relaxed">

        {/* 1 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">1. Предмет соглашения</h2>
          <p>
            Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует
            отношения между <strong>[ОПЕРАТОР]</strong> (далее — «Администрация»)
            и пользователем образовательного сервиса Quantile Camp (далее — «Сервис»,
            «Платформа»).
          </p>
          <p className="mt-2">
            Использование Сервиса в любой форме означает полное и безоговорочное
            принятие условий настоящего Соглашения (акцепт оферты в соответствии
            со ст. 438 ГК РФ).
          </p>
          <p className="mt-2">
            Сервис является информационно-образовательным ресурсом и{" "}
            <strong>не является лицензированной образовательной организацией</strong> в
            соответствии с ФЗ-273 «Об образовании в Российской Федерации». Сервис не
            выдаёт документы об образовании государственного образца.
          </p>
        </section>

        {/* 2 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">2. Условия доступа</h2>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>Сервис предназначен для лиц, достигших 14 лет</li>
            <li>Для получения полного доступа требуется регистрация через Telegram</li>
            <li>
              Пользователь несёт ответственность за сохранность доступа к своему
              аккаунту Telegram
            </li>
          </ul>
        </section>

        {/* 3 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">3. Запрещённые действия</h2>
          <p className="mb-2">При использовании Сервиса запрещается:</p>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>Автоматизированный сбор данных (парсинг, скрейпинг) без письменного разрешения</li>
            <li>Нарушение работы платформы (DDoS-атаки, инъекции, эксплуатация уязвимостей)</li>
            <li>Использование персональных данных других пользователей</li>
            <li>
              Нарушение исключительных прав на учебные материалы Сервиса
              (ч. 4 ГК РФ)
            </li>
            <li>Любые действия, нарушающие законодательство Российской Федерации</li>
          </ul>
        </section>

        {/* 4 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">4. Интеллектуальная собственность</h2>
          <p>
            Все учебные материалы, задачи, тексты курсов, дизайн и программный код
            Сервиса являются объектами интеллектуальной собственности Администрации
            или правообладателей, предоставивших соответствующие лицензии.
          </p>
          <p className="mt-2">
            Пользователю предоставляется неисключительная, непередаваемая лицензия
            на использование материалов Сервиса исключительно в личных некоммерческих
            образовательных целях.
          </p>
        </section>

        {/* 5 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">5. AI-тьютор</h2>
          <p className="mb-2">
            Сервис использует сторонние системы искусственного интеллекта (DeepSeek,
            Google Gemini, OpenAI, Fireworks AI) для функции AI-тьютора.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 space-y-2">
            <p className="text-sm font-semibold text-amber-800">Важно:</p>
            <ul className="list-disc list-inside space-y-1 text-sm text-amber-800 pl-2">
              <li>
                Ответы AI-тьютора генерируются автоматически и могут содержать
                неточности, ошибки или устаревшую информацию
              </li>
              <li>
                Ответы AI-тьютора не являются профессиональной технической консультацией
              </li>
              <li>
                Администрация не несёт ответственности за содержание ответов,
                сгенерированных AI
              </li>
              <li>
                Проверяйте критически важную информацию в официальной документации
                ClickHouse
              </li>
            </ul>
          </div>
          <p className="mt-3 text-sm text-neutral-text/70">
            Используя функцию AI-тьютора, пользователь принимает пользовательские
            соглашения соответствующих AI-провайдеров.
          </p>
        </section>

        {/* 6 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">6. Ограничение ответственности</h2>
          <p>
            Сервис предоставляется «как есть» (as is) без каких-либо гарантий
            бесперебойной работы, точности контента или пригодности для конкретных целей.
          </p>
          <p className="mt-2">
            Администрация не несёт ответственности за прямые или косвенные убытки,
            возникшие в результате использования или невозможности использования Сервиса.
          </p>
          <p className="mt-2">
            При бесплатном использовании максимальная ответственность Администрации
            составляет 0 (ноль) рублей.
          </p>
        </section>

        {/* 7 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">7. Изменение условий</h2>
          <p>
            Администрация вправе в одностороннем порядке вносить изменения в настоящее
            Соглашение. Актуальная версия публикуется на данной странице. Продолжение
            использования Сервиса после публикации изменений означает их принятие.
          </p>
        </section>

        {/* 8 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">8. Применимое право и споры</h2>
          <p>
            Настоящее Соглашение регулируется законодательством Российской Федерации.
          </p>
          <p className="mt-2">
            Споры, возникающие в связи с Соглашением, разрешаются путём переговоров.
            Претензионный (досудебный) порядок урегулирования обязателен.
            Срок ответа на претензию — 30 (тридцать) календарных дней. При недостижении
            согласия спор передаётся в суд по месту нахождения Администрации.
          </p>
        </section>

        {/* 9 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">9. Контактные данные</h2>
          <p>
            По всем вопросам, связанным с использованием Сервиса:
          </p>
          <p className="mt-2">
            <strong>Администрация:</strong> [ОПЕРАТОР]<br />
            <strong>Email:</strong>{" "}
            <a href="mailto:[EMAIL]" className="text-primary hover:underline">
              [EMAIL]
            </a>
          </p>
        </section>

      </div>
    </div>
  );
}
